import { Box, CircularProgress, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { steps } from "../../Helper/AppStepperData";

function calculateProgress(stepData) {
  let totalStep = 0, completedStep = 0;
  if (stepData?.length > 0) {
    steps.forEach(step => {
      totalStep += step.nestedSteps.length
    })
    stepData.forEach(step => {
      completedStep += step
    })
  }
  return ((completedStep / totalStep) || 0) * 100;
}

function CircularProgressBar(props) {
  const { text, style, isObjectionScreen } = props;
  const stepper = useSelector(state => state.storeState.stepper) || [];
  let progress = calculateProgress(stepper)

  return (
    <div style={style || {}}>
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress variant="determinate" value={isObjectionScreen ? 100 : progress || 0} style={{ color: "#FED407" }} />
        <Box sx={{ top: 0, left: 0, bottom: 0, right: 0, position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography variant="caption" component="div" color="text.secondary" style={{ color: "#fff" }}>
            {isObjectionScreen ? "100%" : `${Math.round(progress || 0)}%`}
          </Typography>
        </Box>
      </Box>
      {text && <Typography variant="caption" component="div" style={{ paddingLeft: 16, color: '#fff' }}>
        {text}
      </Typography>}
    </div>
  )
}

export default CircularProgressBar;